import React from 'react';

import Table from 'components/Table';

import {KYC_SECTIONS_META} from 'ducks/bookings';

import {formatDate} from 'utils/datetime';

import './styles.css';

const renderRow = documentRequest => (
  <Table.Row key={documentRequest.id} className="KycRequestDocumentRow">
    <Table.Cell>{formatDate(documentRequest.createdAt)}</Table.Cell>
    <Table.Cell>{documentRequest.requestedBy}</Table.Cell>
    <Table.Cell className="title">{documentRequest.title}</Table.Cell>
    <Table.Cell className="message">{documentRequest.message}</Table.Cell>
  </Table.Row>
);

const KycRequestDocumentTable = ({sectionType, documentRequests}) => (
  <div className="KycRequestDocumentTable KycTable">
    <div className="tableHeading">
      {KYC_SECTIONS_META[sectionType].VERBOSE} Request History
    </div>
    <Table>
      <Table.Header>
        <Table.HeaderItem className="date" heading="date" />
        <Table.HeaderItem className="requestedBy" heading="requested by" />
        <Table.HeaderItem className="title" heading="title" />
        <Table.HeaderItem className="message" heading="message" />
      </Table.Header>
      <Table.Body>{documentRequests.map(renderRow)}</Table.Body>
    </Table>
  </div>
);

export default KycRequestDocumentTable;
